import type { TechTrackingConfiguration } from '@thehotelsnetwork/vue-tech-tracking';

const env = import.meta.env || {};

export const settings: TechTrackingConfiguration = {
  applicationId: '1ed4d887-8854-4d42-a78e-561fc5e17459',
  clientToken: 'pub43525aed0d875bb52121cc8994071255',
  site: 'datadoghq.eu',
  service: 'benchdirect-ui-prd',
  version: '1.0.0',
  env: env.PROD ? 'prd' : 'stg',
  sessionSampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  defaultPrivacyLevel: 'mask-user-input',
};
